(() => {
  if (window.rrShowcaseLoaded) return;
  window.rrShowcaseLoaded = true;
  const showcases = new Map();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = window.matchMedia('(pointer: fine)');
  const initialize = scope => [
    ...(scope.matches?.('[data-showcase]') ? [scope] : []),
    ...scope.querySelectorAll('[data-showcase]')
  ].forEach(showcase => {
    if (showcases.has(showcase)) return;
    const toggle = showcase.querySelector('[data-motion-toggle]');
    if (!toggle) return;
    const video = showcase.querySelector('video');
    const controller = new AbortController();
    let userPaused = preference.matches;
    let visible = true;
    let frame = 0;
    let position = { x: 0, y: 0 };
    const updateButton = () => {
      showcase.classList.toggle('is-paused', userPaused);
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      toggle.querySelector('path').setAttribute('d', userPaused ? 'M7 4l8 6-8 6z' : 'M7 5v10M13 5v10');
      toggle.hidden = !video && preference.matches;
    };
    const sync = () => {
      updateButton();
      showcase.classList.toggle('is-background-paused', userPaused || !visible || document.hidden);
      if (!video) return;
      if (userPaused || !visible || document.hidden) { video.pause(); return; }
      video.muted = true;
      const play = video.play();
      play?.catch(() => {
        if (!visible || document.hidden || userPaused || !showcase.isConnected) return;
        userPaused = true;
        updateButton();
      });
    };
    toggle.addEventListener('click', () => { userPaused = !userPaused; sync(); }, { signal: controller.signal });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      showcase.classList.toggle('is-outside', !visible);
      sync();
    }, { threshold: 0.05 }) : null;
    observer?.observe(showcase);
    if (showcase.matches('[data-interactive-hero]')) {
      const render = () => {
        frame = 0;
        showcase.style.setProperty('--hero-x', `${position.x}px`);
        showcase.style.setProperty('--hero-y', `${position.y}px`);
      };
      showcase.addEventListener('pointermove', event => {
        if (!pointer.matches || preference.matches || userPaused || !visible) return;
        const rect = showcase.getBoundingClientRect();
        position = { x: ((event.clientX - rect.left) / rect.width - .5) * 40, y: ((event.clientY - rect.top) / rect.height - .5) * 28 };
        if (!frame) frame = requestAnimationFrame(render);
      }, { passive: true, signal: controller.signal });
      showcase.addEventListener('pointerleave', () => {
        position = { x: 0, y: 0 };
        if (!frame) frame = requestAnimationFrame(render);
      }, { signal: controller.signal });
    }
    showcases.set(showcase, {
      sync,
      preferenceChanged() { userPaused = preference.matches; sync(); },
      destroy() { controller.abort(); observer?.disconnect(); cancelAnimationFrame(frame); video?.pause(); }
    });
    sync();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    showcases.forEach((state, showcase) => {
      if (event.target.contains(showcase)) { state.destroy(); showcases.delete(showcase); }
    });
  });
  preference.addEventListener('change', () => showcases.forEach(state => state.preferenceChanged()));
  document.addEventListener('visibilitychange', () => showcases.forEach(state => state.sync()));
})();
